import { useState, type FormEvent } from "react";
import { Navigate, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useLogin, useMe } from "../lib/auth";
import { ApiError } from "../lib/api";

export function LoginPage() {
  const { data: me, isLoading } = useMe();
  const login = useLogin();
  const nav = useNavigate();
  const loc = useLocation();
  const [params] = useSearchParams();
  const from = (loc.state as { from?: string } | null)?.from ?? "/inbox";

  const [username, setUsername] = useState(params.get("username") ?? "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  if (isLoading) return null;
  if (me) return <Navigate to={from} replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await login.mutateAsync({ username, password });
      nav(from, { replace: true });
    } catch (e) {
      if (e instanceof ApiError) {
        setError(e.status === 429 ? "Zu viele Versuche — bitte später erneut." : "Login fehlgeschlagen.");
      } else {
        setError("Verbindungsfehler.");
      }
    }
  }

  return (
    <div className="min-h-screen grid place-items-center px-5 py-12 bg-ios-bg">
      <div className="w-full max-w-sm animate-slide-up">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto rounded-iosXl bg-ios-blue grid place-items-center text-white text-3xl shadow-card mb-4">
            🧾
          </div>
          <h1 className="text-[28px] font-semibold tracking-tight">Quittungen</h1>
          <p className="text-[15px] text-ios-muted mt-1">Anmelden, um fortzufahren</p>
        </div>

        <form onSubmit={onSubmit} className="ios-card p-5 space-y-3" autoComplete="on">
          <input
            type="text"
            name="username"
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            inputMode="text"
            placeholder="Benutzername"
            className="ios-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
          <input
            type="password"
            name="password"
            autoComplete="current-password"
            placeholder="Passwort"
            className="ios-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && (
            <div className="text-[13px] text-ios-red bg-ios-red/10 rounded-ios px-3 py-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            className="ios-btn-primary w-full"
            disabled={login.isPending || !username || !password}
          >
            {login.isPending ? "Anmelden…" : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
